import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyBuyingWizardTranslations = wrapTranslationsSchema({
	name: 'BuyEasyBuyingWizardTranslations',
	title: 'Buying Wizard Translations',
	sanityId: 'buyeasy-wizard',
	fields: {
		forYourPurchase: 'FOR Your PURCHASE with',
		viewTheCatalog: 'View the catalog',
		forThisSupplier: 'for this supplier',
		startAgain: 'Start again',
		findYourSupplier: 'Find your supplier',
		weWillHelp: 'How to buy - We’ll help you make the right choice',
		questionNotFound: 'Question not found for {question}. Available questions: {questions}',
		catalogFor: 'Catalog For {supplier}',
		category: 'Category',
		categoryTags: 'Category tags',
		preferredStatus: 'Preferred Status',
		tprmStatus: 'TPRM Status',
		tprm: 'Tprm',
		loadMore: 'Load more',
		preferred: 'Preferred',
		preferredInProgress: 'Preferred in progress',
		all: 'All',

		supplierNotFound:
			'Supplier with ID {supplierId} not found. Please go back and search for another Supplier.',
		searchForSuppliers: 'Search for suppliers',

		tprmCompliant: 'TPRM Compliant',
		tprmNonCompliant: 'TPRM Non-compliant',
		tprmNonApplicable: 'TPRM Non-applicable',
		tprmAndCategories: 'TPRM and Categories',
		categories: 'Categories',

		tprmWarningHeader: 'Your Purchase is Not TPRM Compliant. Are you sure you want to proceed?',
		tprmWarningSubHeader:
			'The Supplier-Category-Takeda Location combination has not been assessed for TPRM Risk:',
		tprmWarningRequestTprm: 'Request tprm',
		tprmWarningSupplier: 'Supplier',
		tprmWarningSupplierId: 'Supplier ID',
		tprmWarningCpCode: 'CP Code',
		tprmWarningCountry: 'Country',
		tprmWarningIfYouContinue:
			'If you continue, you assume compliance risk. Please choose how to proceed.',
		tprmWarningGoBackAndChange: 'Go Back and Change',

		noSupplierInfoText:
			'Please note that this “How to Buy Wizard” is working without any Supplier selected. If you wish to start your guidance with a Supplier, go to the {suppliers} page and find the right one for you.',
		noSupplierInfoTextLinkLabel: 'Suppliers',

		pleaseNote: 'Please note that TPRM status cannot be checked without a Supplier.',
		withoutSupplier: 'How to Buy guidance without Supplier.',

		whatCategoryDoesYour: 'What category does your purchase fall under?',
		valueAndApplicability: 'Value and Applicability',
		fillOutTheFormWith: 'Fill out the form with additional information?',
		results: 'Results',
		hereAreTheSuitableBuyingChannels: 'Here are the suitable buying channels for you:',
	},
});
